import PropTypes from 'prop-types';
import { Checkbox } from '@mui/material';

const CheckboxDisplay = (props) => {
  const { checked } = props;

  return (
    <Checkbox
      disabled
      checked={checked}
    />
  );
};

CheckboxDisplay.propTypes = {
  checked: PropTypes.bool.isRequired
};

export default CheckboxDisplay;
